import { Injectable } from '@angular/core';
import { ReasonDal } from '../dal/reason.dal';
import { Reason } from '../models/reason.model';

@Injectable({
  providedIn: 'root',
})
export class ReasonService {
  constructor(private reasonDal: ReasonDal) {}

  getAllReasons(hospitalId?: string) {
    return this.reasonDal.getAllReasons(hospitalId);
  }

  getReason(isNight: boolean, hospital?: string) {
    if (isNight) {
      return this.reasonDal.getNightReasons(hospital);
    }
    return this.reasonDal.getDayReasons(hospital);
  }

  getReasonsWithoutRule() {
    return this.reasonDal.getReasonsWithoutRule();
  }

  addReason(reason: any) {
    return this.reasonDal.addReason(reason);
  }

  editReason(reason: Reason) {
    return this.reasonDal.editReason(reason);
  }
}
